var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',[_c('v-tab',{attrs:{"to":{
      name: 'ProgressGoalSettingBehaviourChangeGoals',
      params: {
        patientId: _vm.patientId,
      },
    }}},[_vm._v(" "+_vm._s(_vm.$ucfirst(_vm.$t("journeyBehaviourChangeGoals.behaviourChangeGoals")))+" ")]),_c('v-tab',{attrs:{"to":{
      name: 'ProgressGoalSettingOutcomeGoals',
      params: {
        patientId: _vm.patientId,
      },
    }}},[_vm._v(" "+_vm._s(_vm.$ucfirst(_vm.$t("journeyOutcomeGoals.outcomeGoals")))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }